import { useMemo } from "react";
import { CustomTable } from "../../../componentes/table/CustomTable";
const T = {
    bg: "#F7F9FC",
    surface: "#FFFFFF",
    surfaceAlt: "#F1F5F9",
    border: "#E2E8F0",
    borderStrong: "#CBD5E1",
    text: "#0F172A",
    textMid: "#475569",
    muted: "#94A3B8",
    primary: "#2563EB",
    primaryLight: "#EFF6FF",
    secondary: "#64748B",
    green: "#16A34A",
    greenLight: "#F0FDF4",
    red: "#DC2626",
    redLight: "#FEF2F2",
    blue: "#0EA5E9",
    blueLight: "#F0F9FF",
    acum: "#EEF2FF",
    acumText: "#4338CA",
    total: "#F8FAFC",
};

export function TabelaPorMontador({ report }) {

    function formatNum(n) {
        if (n == null) return "0";
        return Number(n).toLocaleString("pt-BR");
    }

    const totais = useMemo(() => {
        return (report || []).reduce(
            (acc, item) => {
                acc.caixas += item.totalCaixas || 0;
                acc.paletes += item.totalPaletes || 0;
                acc.erros += item.totalErros || 0;
                acc.horas += item.totalHora || 0;
                return acc;
            },
            { caixas: 0, paletes: 0, erros: 0, horas: 0 }
        );
    }, [report]);

    const dataComSeq = useMemo(() => {
        return (report || []).map((item, index) => ({
            ...item,
            seq: index + 1
        }));
    }, [report]);

    const columns = [
        {
            key: "seq",
            label: "SEQ",
            center: true,
            sortable: false,
            render: (_, __, index) => index + 1
        },
        {
            key: "funcionario",
            label: "Montador",
        },
        {
            key: "totalCaixas",
            label: "Caixas",
            center: true,
            format: "number",
            className: "font-semibold"
        },

        {
            key: "totalPaletes",
            label: "Paletes",
            className: "font-semibold",
            center: true,
            format: "number"
        },
          {
            key: "totalErros",
            label: "Erros",
            center: true,
            format: "number"
        },
        {
            key: "mediaPaletes",
            label: "Paletes/Dia",
            format: "number",
            render: item => item?.toFixed(2)
        },
             {
            key: "mediaCaixas",
            label: "Caixas/Dia",
            format: "number",
            render: item => item?.toFixed(2)
        },
      
        {
            key: "totalHora",
            label: "Total Horas",
            center: true,
            render: (v) => Number(v || 0).toFixed(2)
        },
        {
            key: "produtividade",
            label: "Produtividade",
            center: true,
            render: (v) => Number(v || 0).toFixed(2),
            className: "font-semibold"
        }
    ];

    return (
        <div className="bg-card rounded-xl shadow-card flex flex-col">

            {/* HEADER igual tabela despesas */}
            <div className="bg-muted rounded-t-2xl flex flex-col gap-3" style={{ padding: "16px 20px 12px" }}>
                <div className="flex items-center gap-2.5">
                    <div className="bg-primary rounded-lg flex items-center justify-center" style={{ width: 32, height: 32 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2">
                            <path d="M3 3h18v18H3z" />
                            <path d="M3 9h18" />
                        </svg>
                    </div>

                    <div>
                        <div className="font-display text-foreground" style={{ fontSize: 15, fontWeight: 700 }}>
                            Produtividade por Montador
                        </div>
                        <div className="text-muted-foreground" style={{ fontSize: 11 }}>
                            Performance individual dos montadores
                        </div>
                    </div>
                </div>
            </div>

            <CustomTable
                data={report || []}
                columns={columns}
                exportable
                exportFilename="produtividade_montadores"
                className="text-[12px]"
                showHeader={false}
                footer={(data) => (
                    <div className="text-xs font-semibold py-2">
                        <span className="mr-6">
                            Caixas: {formatNum(totais.caixas)}
                        </span>

                        <span className="mr-6">
                            Paletes: {formatNum(totais.paletes)}
                        </span>

                        <span className="mr-6">
                            Erros: {formatNum(totais.erros)}
                        </span>

                        <span className="mr-6">
                            Horas: {totais.horas.toFixed(2)}
                        </span>

                        <span>
                            Produtividade: {(totais.caixas / (totais.horas || 1)).toFixed(2)}
                        </span>
                    </div>
                )}
            />
        </div>
    );
}